module.exports = __webpack_public_path__ + "img/title.119e30d7.png";